var map = {
	"./command-line-fundamentals/manifest.json": 30156,
	"./demo/manifest.json": 6198,
	"./python-fundamentals/manifest.json": 14112,
	"./python-in-the-cloud-sqs/manifest.json": 13352,
	"./python-in-the-cloud/manifest.json": 24235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2275;